import { render, staticRenderFns } from "./TokenHelpModal.vue?vue&type=template&id=23f38160"
import script from "./TokenHelpModal.vue?vue&type=script&lang=js"
export * from "./TokenHelpModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports